import React from 'react';

import { observer } from 'mobx-react';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';

import { Button } from 'components/Button';

import { useNavBarHeight } from 'utils/hooks/navbar';

import AddEntityModal from 'components/Entities/AddEntityModal/AddEntityModal';
import { useStore } from 'utils/hooks/store';
import { risksRegisterPath } from 'utils/risksRegisterPath';

import RisksTable from './components/RisksTable';

const Risks: React.FunctionComponent = observer((): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const [openModal, setOpenModal] = React.useState(false);
  const refreshRef = React.useRef<Function | null>(null);
  const { riskDetails, session } = useStore();
  const registerPath = risksRegisterPath(session.user);

  const onClose = (created: boolean): void => {
    setOpenModal(false);
    if (refreshRef.current && created) {
      refreshRef.current();
    }
  };
  const onRefreshCallback = (callback: Function): void => {
    refreshRef.current = callback;
  };

  return (
    <>
      <Record
        Header={
          <MainHeader
            title="Risk Register"
            breadcrumbs={[
              { label: 'Risk Register', link: registerPath },
              { label: 'Overview', link: registerPath },
            ]}
            action={
              <Button variant="contained" size="large" onClick={() => setOpenModal(true)}>
                New
              </Button>
            }
          />
        }
        Content={(onError) => <RisksTable onError={onError} onRefreshCallback={onRefreshCallback} />}
        navBarHeight={navBarHeight}
      />
      {openModal && <AddEntityModal store={riskDetails} onClose={onClose} />}
    </>
  );
});

export default Risks;
